import { useMutation } from 'react-query';
import { visitRequest } from '@services/VisitRequest/VisitRequest';
import { AxiosError } from 'axios';

export function useSubmitVisitRequestForm() {
  return useMutation<string, AxiosError, FormData>(async (requestData: FormData) => {
    const { data } = await visitRequest.submitVisitRequest(requestData);
    return data;
  });
}
